import {LayoutClasses} from '@app/player/playlist-player.component.base';
import {HtmlOverlayLayoutComponent} from '@app/player/layout/html-overlay-layout.component';

export const layoutClasses: LayoutClasses = {
    default: HtmlOverlayLayoutComponent,
    'HTML-Overlay': HtmlOverlayLayoutComponent,
};
